<template>
  <!-- 单品方案设计 -->
  <div class="addPromActivity">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title + ' ' + typeData[addForm.type]"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="width: 100%;height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="right" label-width="120px" :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="addForm.name" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="促销类型" prop="type">
            <el-select v-model="addForm.type" placeholder="促销类型" style="width:200px;margin-right:5px" disabled>
              <el-option label="换购" value="DHG"></el-option>
              <el-option label="买赠" value="DMZ"></el-option>
              <el-option label="折扣" value="DZK"></el-option>
              <el-option label="抢购" value="DQG"></el-option>
              <el-option label="满减" value="DMJ"></el-option>
              <el-option label="组合" value="GZH"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="开始时间" prop="startTime">
            <el-date-picker v-model="addForm.startTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="结束时间" prop="endTime">
            <el-date-picker v-model="addForm.endTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss" style="width:200px;" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="促销规则" prop="ruleId">
            <el-input readonly v-model="addForm.ruleData.name" style="width:200px;" @click.native="getRuleData"
              placeholder="单击选择"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button v-if="status == 1" type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>

    <!-- 促销规则选择 -->
    <el-dialog title="促销规则" :visible.sync="dialogVisible" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="70%">
      <search-bar>
        <template>
          <el-input style="width:200px;margin-right:5px" clearable placeholder="输入编号/名称" v-model="searchForm.name">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getRuleData">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="ruleList" stripe border @row-click="rowClick" tooltip-effect="dark" height="400">
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="entid" label="机构">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="ruleCode" label="规则编号">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="ruleTitle" label="规则标题">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="faName" label="规则类型">
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="describe" label="规则描述">
        </el-table-column>
      </el-table>
      <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanCurrChange="hanCurrChange"
        layout="total, prev, pager, next, jumper"></pagination>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'addPromActivity',
  data() {
    return {
      status: "2",//促销规则的状态 2启用 1禁用
      id: '',
      entid: '',
      typeData: {
        DHG: "换购",
        DMZ: "买赠",
        DZK: "折扣",
        DQG: "抢购",
        DMJ: "满减",
        GZH: "组合",
      },
      /**新增表单 */
      addForm: {
        name: "", // 活动名称
        type: "", // 活动类型
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        ruleId: "", // 规则ID
        // 规则数据
        ruleData: {
          name: '' // 规则名称
        },
      },
      /**表单规则 */
      addFormRule: {
        name: [mustFill],
        type: [mustFill],
        startTime: [mustFill],
        endTime: [mustFill],
        ruleId: [mustFill],
      },
      ruleList: [],
      dialogVisible: false,
      currPage: 1,
      pageSize: 10,
      allPage: 0,
      searchForm: {
        name: ''
      },
    }
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams.type) {
      this.addForm.type = prams.type
    }
    if ('status' in prams) {
      this.status = prams.status;
    }
    if (prams.id) {
      this.id = prams.id
      this.entid = prams.entid
      this.getPromActivity()
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    // 获取促销活动详情
    getPromActivity() {
      let data = {
        type: "QuerySingleProm",
        entid: this.entid,
        salesCode: this.id
      };
      this.$requestSys({
        method: "post",
        url: "prom/ashx/PromSales.ashx?json=" + encodeURIComponent(JSON.stringify(data)),
      }).then((res) => {
        if (res.flag == 0) {
          this.addForm.name = res.promSales.salesName
          this.addForm.startTime = res.promSales.startDate
          this.addForm.endTime = res.promSales.endDate
          this.addForm.ruleId = res.promSales.ruleCode
          this.getPromRule(res.promSales.ruleCode)
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    // 获取促销规则详情
    getPromRule(id) {
      let data = {
        type: "QuerySingleProm",
        entid: this.entid,
        ruleCode: id
      };
      this.$requestSys({
        method: "post",
        url: "prom/ashx/PromRule.ashx?json=" + encodeURIComponent(JSON.stringify(data)),
      }).then((res) => {
        if (res.flag == 0) {
          this.addForm.ruleData.name = res.promRule.ruleTitle
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    // 字符串转化
    changeStr(str) {
      if (str.indexOf('&nbsp;') != -1) {
        str = str.split('&nbsp;')[0].split('：')[1]
      }
      return str
    },
    // 获取规则数据
    getRuleData() {
      let data = {
        type: "QueryPromList",
        faType: this.addForm.type,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      this.$requestSys({
        method: "post",
        url: "prom/ashx/PromRuleList.ashx?json=" + encodeURIComponent(JSON.stringify(data)),
        dataType: "json"
      }).then((res) => {
        if (res.flag == 0) {
          this.ruleList = res.data
          this.allPage = res.recordCount
          this.dialogVisible = true
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getRuleData()
    },
    // 单击弹框数据
    rowClick(row) {
      this.addForm.ruleId = row.ruleCode
      this.addForm.ruleData.name = row.ruleTitle
      this.dialogVisible = false
    },
    /**提交表单 */
    submit() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let data = {
            type: "SaveProm",
            faname: this.addForm.name,
            ruleCode: this.addForm.ruleId,
            salesCode: this.id,
            fabs: '',
            faType: this.addForm.type,
            startDates: this.addForm.startTime,
            endDates: this.addForm.endTime,
          };
          this.$requestSys({
            method: "post",
            url: "prom/ashx/PromSales.ashx?json=" + encodeURIComponent(JSON.stringify(data)),
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.goBack()
            } else {
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err)
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.addPromActivity {
  width: 100%;
  height: 100%;
}
</style>
